export default __webpack_public_path__ + "static/media/question.b2389d33.mp3";